<template>
	<div class="study">
		<publicHeader @child-event="myInfoEvent"></publicHeader>
		<studyHeader :subjectIndex="subjectIndex" :studyNav="studyNav" :myInfo="myInfo" :public="public"></studyHeader>
		
		<div class="study_adver">
			<router-link :to="adver.url"><img :src="adver.img" class="block" /></router-link>
		</div>
		<div class="hot w1200">
			<div class="hot_header tc">
				<h3 class="f26px bold">热门视频</h3>
				<p class="f18px cl_tip mat5">HOT VIDEO</p>
			</div>
			<div class="hot_cont">
				<ul class="hot_ul">
					<li class="hot_list" v-for="(item,index) in hot" :key="index">
						<router-link :to="{ path: '/video', query: { id: item.id}}" class="block">
							<img :src="item.pic" class="hot_list_img" />
							<div class="hot_list_text">
								<h3 class="f16px mat10"><img src="../../../static/icon_time.png" /><span>{{item.add_time}}</span></h3>
								<p class="cl_gray f12px mat10">已观看：{{item.browse_num}}人</p>
							</div>
						</router-link>
					</li>
				</ul>
			</div>
			<div class="study_selected mat80">
				<course-group @child-event="selectedCheck" :groupInfo="selectedInfo" :groupNav="selectedNav" :groupCont="selectedCont" :groupCurrent="selectedCurrent"></course-group>
			</div>
			<div class="study_subject mat80">
				<course-group2 @child-event="subjectCheck" :groupInfo="subjectInfo" :groupNav="subjectNav" :groupCont="subjectCont" :groupCurrent="subjectCurrent"></course-group2>
			</div>
		</div>
		<!-- <div class="study_like bg_gray">
			<div class="w1200">
				<div class="hot_header tc">
					<h3 class="f26px bold">猜你喜欢</h3>
					<p class="f18px cl_tip mat5">GUESS WHAT YOU LIKE</p>
				</div>
				<div class="study_like_cont">
					<router-link to="" v-for="(item,index) in likeList" :key="index" class="study_like_list">
						<img :src="item.img" class="block radius8" />
						<p class="clip f20px mat5">{{item.name}}</p>
					</router-link>
				</div>
			</div>
		</div> -->
		<div class="why">
			<div class="why_top">
				<div class="w1200">
					<img src="../../../static/link_white.png" />
					<p class="f18px cl_gray">————— 为何选择趣学云课堂？ —————</p>
				</div>
			</div>
			<div class="why_btm">
				<div class="w1200">
					<ul class="why_ul">
						<li class="why_list">
							<img src="../../../static/advantage_01.png" classs="why_list_img" />
							<div class="why_list_text">
								<h3 class="cl_dark f18px">网络课堂</h3>
								<p class="cl_gray">随时随地上课</p>
								<p class="cl_gray">价格仅线下课程的1/3</p>
							</div>
						</li>
						<li class="why_list">
							<img src="../../../static/advantage_02.png" classs="why_list_img" />
							<div class="why_list_text">
								<h3 class="cl_dark f18px">官方网站</h3>
								<p class="cl_gray">趣学云教育公司旗下</p>
								<p class="cl_gray">官方网络课堂</p>
							</div>
						</li>
						<li class="why_list">
							<img src="../../../static/advantage_03.png" classs="why_list_img" />
							<div class="why_list_text">
								<h3 class="cl_dark f18px">雄厚师资</h3>
								<p class="cl_gray">丰富的教师资源</p>
								<p class="cl_gray">目前有超200位各学笠老师</p>
							</div>
						</li>
						<li class="why_list">
							<img src="../../../static/advantage_04.png" classs="why_list_img" />
							<div class="why_list_text">
								<h3 class="cl_dark f18px">优质课程</h3>
								<p class="cl_gray">优质课程设计</p>
								<p class="cl_gray">专注高效提分</p>
							</div>
						</li>
					</ul>
				</div>
			</div>
		</div>
		<vfooter @child-event="publicEvent"></vfooter>
	</div>
</template>

<script>
	import publicHeader from '../../components/header.vue'
	import studyHeader from '../../components/study_header.vue'
	import vfooter from '../../components/footer.vue'
	import courseGroup from '../../components/course_group.vue'
	import courseGroup2 from '../../components/course_group.vue'
	export default {
	  name: 'study',
		components: {
			publicHeader,
			studyHeader,
			vfooter,
			courseGroup,
			courseGroup2,
		},
	  props: {
	    
	  },
		data () {
			return {
				studyNav: 0,
				subjectIndex: true, //学科分类显示
				myInfo: {},
				public: {},
				adver: {	//广告
					url: "",
					img: require("../../../static/study_banner.png"),
				},
				hot: [], //热门视频
				//精选课程、学科
				selectedCurrent: 0,
				selectedInfo: {
					bg: require("../../../static/course_bg_01.png"),
					title: '精选课程',
					titleVice: 'SELECT THE CLASS',
					cont: '名师点拨 不一样的套路,名师点拨 不一样的套路',
				},
				selectedNav: [],
				selectedCont: [],
				subjectCurrent: 0,
				subjectInfo: {
					bg: require("../../../static/course_bg_02.png"),
					title: '学科课程',
					titleVice: 'SUBJECT CURRICULUM',
					cont: '因为一个好老师 从此爱上一门课程',
				},
				subjectNav: [],
				subjectCont: [],
				likeList: [],
			}
		},
		mounted() {
			this.getHotvideo();
			this.getSelect();
			this.getClass();
		},
		methods: {
			//热门视频
			getHotvideo () {
				var that = this;
				that.$get("/api/course/course_index_hot_data",{
					pharse_id: localStorage.getItem("pharseId"),
					limit: 5,
				})
				.then(res => {
					that.hot = res.data;
				});
			},
			//精选课程
			getSelect () {
				var that = this;
				that.$get("/api/Course/course_index_grade_data",{
					pharse_id: localStorage.getItem("pharseId")
				})
				.then(res => {
					that.selectedCont = res.data;
				});
			},
			//学科分类
			getClass () {
				var that = this;
				that.$get("/api/Course/subject_index_data",{})
				.then(res => {
					that.subjectNav = res.data;
					that.getClasscoures()
				});
			},
			//学科课程
			getClasscoures () {
				var that = this;
				that.$get("/api/Course/course_index_subject_data",{
					pharse_id: localStorage.getItem("pharseId"),
					subject_id: that.subjectNav[that.subjectCurrent].subjectId
				})
				.then(res => {
					that.subjectCont = res.data;
				});
			},
			
			selectedCheck (data) {
				this.selectedCurrent = data;
			},
			subjectCheck (data) {
				this.subjectCurrent = data;
				this.getClasscoures();
			},
			myInfoEvent (data) {
				this.myInfo = data;
			},
			publicEvent (data) {
				this.public = data;
			},
		},
	}
</script>

<style>
</style>
